module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 18 Farma Pasa - Pustoparan bonus (gost. Luka Nikolić).04c464e2.mp3";